<div class="col">

	<div class="col-12 button-container" *ngFor="let menuItem of menuItems">
		<button *ngIf="menuItem.visible" pButton [routerLink]="menuItem.routerLink"
				[label]="menuItem.label"
				[icon]="menuItem.icon"
				type="button"
				class="button">
		</button>
	</div>
</div>
